import { ListType } from '@convergence/types';
import { valueFromTreeAndPath } from './util';
import { AnalysisValueProps } from './types';
import { AnalysisSwitchValue } from './analysis-switch-value';

export function AnalysisList(props: AnalysisValueProps<ListType>) {
  let value = valueFromTreeAndPath<any[]>(props.tree, props.propertyPath) ?? [];

  return (
    <div className="py-2">
      <span className="text-orange-2">{props.name}</span>
      <ul>
        {value.map((item, index) => (
          <li className="flex items-center gap-2 pl-4 py-2">
            <div className="w-4 border-l border-y border-black self-stretch"></div>
            <AnalysisSwitchValue
              value={item}
              tree={props.tree}
              propertyPath={[...props.propertyPath, '_value', String(index)]}
              name=""
              key={index}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
